// extracted by mini-css-extract-plugin
export default {"modal":"modal-calc_modal__1kOva","content":"modal-calc_content__-DyZz","buttons":"modal-calc_buttons__iFcXU","button":"modal-calc_button__5iDss"};